import React, { useState } from "react";
import { Grid, GridRow } from "semantic-ui-react";
import Recipe from "./Recipe";

const RecipeList = ({ recipes }) => {
  const recipesPerPage = 9;
  const itemsPerRow = 3;
  const [currentPage, setCurrentPage] = useState(1);

  const indexOfLastRecipe = currentPage * recipesPerPage;
  const indexOfFirstRecipe = indexOfLastRecipe - recipesPerPage;
  const currentRecipes = recipes.slice(indexOfFirstRecipe, indexOfLastRecipe);

  const totalPages = Math.ceil(recipes.length / recipesPerPage);
  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  return (
      <div className="recipe-card">
          {currentRecipes.map((recipe) => (
            <div key={recipe.id}>
              <Recipe recipe={recipe} />
            </div>
          ))}
      </div>
  );
};

export default RecipeList;